import React from 'react';
import { cn } from '@/lib/utils';
import type { PageHeaderProps } from './PageHeader.types';

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  breadcrumbs,
  className,
}) => (
  <div data-testid="page-header" className={cn('mb-6', className)}>
    {breadcrumbs && (
      <nav className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400 mb-2">
        {breadcrumbs.map((crumb, index) => (
          <React.Fragment key={crumb.label}>
            {index > 0 && <span className="text-slate-300 dark:text-slate-600">/</span>}
            <span
              className={cn(
                crumb.active
                  ? 'text-slate-900 dark:text-slate-100 font-medium'
                  : 'hover:text-slate-700 dark:hover:text-slate-300 cursor-pointer'
              )}
            >
              {crumb.label}
            </span>
          </React.Fragment>
        ))}
      </nav>
    )}
    <div className="flex items-start justify-between gap-4">
      <div>
        <h1
          data-testid="page-title"
          className="text-2xl font-bold font-heading text-slate-900 dark:text-slate-100 tracking-tight"
        >
          {title}
        </h1>
        {subtitle && (
          <p
            data-testid="page-subtitle"
            className="mt-1 text-sm text-slate-500 dark:text-slate-400"
          >
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div data-testid="page-actions" className="flex items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  </div>
);
